import React, { useState } from 'react';
import { Edit2, Check, X } from 'lucide-react';

export default function EditablePersonalizedLine({ patient, onUpdate }) {
  const [isEditing, setIsEditing] = useState(false);
  const [value, setValue] = useState(patient.personalizedLine || '');

  function handleSave() {
    onUpdate(patient.id, { personalizedLine: value });
    setIsEditing(false);
  }

  function handleCancel() {
    setValue(patient.personalizedLine || '');
    setIsEditing(false);
  }

  if (isEditing) {
    return (
      <div style={editContainerStyle}>
        <input
          style={editInputStyle}
          value={value}
          onChange={e => setValue(e.target.value)}
          placeholder="Add a personalized line..."
          autoFocus
          onKeyDown={e => {
            if (e.key === 'Enter') handleSave();
            if (e.key === 'Escape') handleCancel();
          }}
        />
        <button onClick={handleSave} style={saveEditBtnStyle} title="Save">
          <Check size={14} />
        </button>
        <button onClick={handleCancel} style={cancelEditBtnStyle} title="Cancel">
          <X size={14} />
        </button>
      </div>
    );
  }

  return (
    <div style={displayContainerStyle}>
      <span style={displayTextStyle}>
        {patient.personalizedLine || (
          <span style={placeholderStyle}>Click to add personalization</span>
        )}
      </span>
      <button 
        onClick={() => setIsEditing(true)} 
        style={editBtnStyle}
        title="Edit personalized line"
      >
        <Edit2 size={12} />
      </button>
    </div>
  );
}

// Styles
const editContainerStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: 6,
  flex: 1,
};

const editInputStyle = {
  flex: 1,
  padding: '4px 8px',
  border: '1px solid #2D9B8A',
  borderRadius: 4,
  fontSize: 12,
  fontFamily: "'Inter', sans-serif",
  color: '#1A3A3A',
  background: '#FFFFFF',
  outline: 'none',
  minWidth: 180,
};

const saveEditBtnStyle = {
  padding: '4px 6px',
  background: '#2D9B8A',
  color: '#FFFFFF',
  border: 'none',
  borderRadius: 4,
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  transition: 'background 0.2s',
};

const cancelEditBtnStyle = {
  padding: '4px 6px',
  background: 'transparent',
  color: '#7A9A92',
  border: '1px solid #DDDEDC',
  borderRadius: 4,
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  transition: 'all 0.2s',
};

const displayContainerStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  flex: 1,
  padding: '4px 0',
};

const displayTextStyle = {
  fontSize: 12,
  color: '#1A3A3A',
  fontFamily: "'Inter', sans-serif",
  fontStyle: 'italic',
  flex: 1,
};

const placeholderStyle = {
  color: '#B5C8C4',
  fontStyle: 'italic',
};

const editBtnStyle = {
  padding: '4px 6px',
  background: 'transparent',
  border: 'none',
  borderRadius: 4,
  cursor: 'pointer',
  color: '#7A9A92',
  display: 'flex',
  alignItems: 'center',
  transition: 'all 0.2s',
  ':hover': {
    background: '#F5F8F7',
    color: '#2D9B8A',
  },
};